import {
  ADD_PRODUCT,
  ITEMS_LIST,
  INCRESE_PRODUCT,
  EDIT_PRODUCT,
  SET_FILTERD_LIST,
  SET_USER_ORDER,
  SET_TRANSFER_MONEY,
  SET_ORDER_PERSON_TYPE,
  SET_PERSON_SEARCH,
  SET_PERSON_OPTIONS,
  SET_SELECTED_PERSON
} from "./cart.type";

const INITIAL_STATE = {
  // Old slice
  order: null,
  transferMoney: null,

  // New logic
  cartItems: [],
  itemsList: [],

  // Order person info
  orderPersonType: "",
  personSearch: "",
  personOptions: [],
  selectedPerson: null,

};

const cartReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Old slice
    case SET_USER_ORDER:
      return { ...state, order: action.payload };
    case SET_TRANSFER_MONEY:
      return { ...state, transferMoney: action.payload };

    // New logic
    case ADD_PRODUCT:
      return {
        ...state,
        cartItems: [action.payload, ...state.cartItems],
      };
    case EDIT_PRODUCT:
      return handleEditItem(state, action.payload);
    case INCRESE_PRODUCT:
      return {
        ...state,
        itemsList: action.payload,
      };
    case ITEMS_LIST:
      return {
        ...state,
        itemsList: action.payload,
      };
    case SET_FILTERD_LIST:
      return {
        ...state,
        itemsList: action.payload,
      };
    case SET_ORDER_PERSON_TYPE:
      return { ...state, orderPersonType: action.payload };

    case SET_PERSON_SEARCH:
      return { ...state, personSearch: action.payload };

    case SET_PERSON_OPTIONS:
      return { ...state, personOptions: action.payload };

    case SET_SELECTED_PERSON:
      return { ...state, selectedPerson: action.payload };
    default:
      return state;
  }
};

function handleEditItem(state, payload) {
  const selectedItemInd = state.cartItems.findIndex(ele => ele.id === payload.id);
  if (selectedItemInd !== -1) {
    // Deep copy
    const updatedCartItems = [...state.cartItems];
    updatedCartItems[selectedItemInd] = {
      ...updatedCartItems[selectedItemInd],
      quantaty: payload.quantaty
    };
    return {
      ...state,
      cartItems: updatedCartItems
    };
  }
  return state;
}

export default cartReducer;
